export default {
  "userName": "用戶名",
  "family": "家庭",
  "familyNumber": "家庭號",
  "search": "搜索",
  "add": "添加",
  "title": "標題",
  "myAccount": "我的帳號",
  "logout": "登出",
  "setting": "設定",
  "changePassword": "修改密碼",
  "errorMessageRequiredInputAny": "請輸入%{name}",
  "errorMessageRequiredSelectAny": "請選擇%{name}",
  "errorMessageUnknownError": "未知錯誤, 請稍後重試",
  "addSuccessMessage": "添加成功",
  "editSuccessMessage": "修改成功",
  "removeSuccessMessage": "刪除成功",
  "createdAt": "創建時間",
  "removeConfirmMessage": "您確定要刪除此數據嗎?",
  "removeErrorMessage": "刪除失敗",
  "tablePaginationTotal": "總共 %{total} 個記錄",
  "tableSearchPlaceholder": "搜索...",
  "productTypeRedemption": "換領乾貨",
  "productTypeSale": "銷售商品",
  "replenishRecordRedemption": "兌換",
  "replenishRecordSale": "銷售",
  "replenishRecordNormal": "出入貨",
  "replenishRecordAdjustment": "盤點",
  "userCoinDateRegular": "定時贈送",
  "userCoinDateExtra": "額外贈送",
  "userCoinDateRedemption": "兌換消費",
  "userCoinDateExpired": "已過期",
}